// src/app/layout/app-layout.component.ts

import { Component, inject, HostListener, OnInit } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { LayoutService } from '../services/layout.service';
import { PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, SidebarComponent, HeaderComponent, RouterOutlet],
  template: `
    <div class="flex h-screen bg-gray-50 dark:bg-gray-950 overflow-hidden transition-colors duration-300">
      <!-- Sidebar -->
      <app-sidebar></app-sidebar>
 
      <!-- Main Content Area -->
      <div class="flex-1 flex flex-col min-w-0 overflow-hidden">
        <!-- Header -->
        <app-header></app-header>
 
        <!-- Page Content -->
        <main class="flex-1 overflow-y-auto p-0 sm:p-1 custom-scrollbar">
          <div class="max-w-8xl mx-auto">
            <router-outlet></router-outlet>
          </div>
        </main>
      </div>
    </div>
  `,
})
export class AppLayoutComponent implements OnInit {
  layoutService = inject(LayoutService);
  private platformId = inject(PLATFORM_ID);

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.layoutService.checkScreenSize(event.target.innerWidth);
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.layoutService.checkScreenSize(window.innerWidth);
    }
  }
}
